import {Breadcrumbs, BreadcrumbsClasses} from "@/shared/ui/Breadcrumbs";
import {mapCatalogBreadcrumbs} from "../model/mapCatalogBreadcrumbs";
import type {SelectedFilter} from "@/entities/catalog";

type Props = {
    selectedFilters?: SelectedFilter[];
    classes?: Partial<BreadcrumbsClasses>
};

export const CatalogBreadcrumbs = (
    {
        selectedFilters = [],
        classes,
    }: Props
) => {
    const items = mapCatalogBreadcrumbs(selectedFilters);

    return (
        <Breadcrumbs
            items={items}
            maxItems={4}
            itemsAfterCollapse={3}
            classes={classes}
        />
    );
};
